module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty3.01510591.jpg";